/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Report-schedule list, editor, copy modal, and recipients modal.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminListModule} from '../common/directives/admin-list.module';
import {AdnSelectModule} from '../common/directives/adn-select/adn-select.module';
import {ReportWidgetsModule} from '../report/report-widgets.module';
import {ReportScheduleEditPageComponent} from './report-schedule-edit-page.component';
import {ReportScheduleListPageComponent} from './report-schedule-list-page.component';
import {ReportScheduleRoutePageComponent} from './report-schedule-route-page.component';
import {ReportScheduleCopyModalComponent} from './report-schedule-copy-modal.component';
import {ReportScheduleRecipientsModalComponent} from './report-schedule-recipients-modal.component';

const REPORT_SCHEDULE = [
  ReportScheduleEditPageComponent,
  ReportScheduleListPageComponent,
  ReportScheduleRoutePageComponent,
  ReportScheduleCopyModalComponent,
  ReportScheduleRecipientsModalComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    TimepickerModule,
    AdminListModule,
    AdnSelectModule,
    ReportWidgetsModule
  ],
  declarations: REPORT_SCHEDULE,
  exports: REPORT_SCHEDULE
})
export class ReportScheduleModule {
}
